
export const formatDateRangePickerValues = (value, dateService, ignoreSecondsAndMilliseconds) => {
    let fromValue = null;
    let toValue = null;
    if (value) {
        if (value[0]) {
            fromValue = dateService.setUnit(value[0], 'seconds', 0);
            fromValue = dateService.setUnit(fromValue, 'minutes', 0);
            fromValue = dateService.setUnit(fromValue, 'milliseconds', 0);
            fromValue = dateService.toISOString(fromValue)
        }

        if (value[1]) {
            toValue = dateService.setUnit(value[1], 'seconds', 0);
            toValue = dateService.setUnit(toValue, 'minutes', 0);
            toValue = dateService.setUnit(toValue, 'milliseconds', 0);
            toValue = dateService.toISOString(toValue)
        }
    }
    return {fromValue, toValue}
}